import React, { useEffect, useState } from 'react';
import "./dash.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
const Dashboard = () => {
    const [dashboardData, setdashboardData] = useState(null)
    const navigate = useNavigate()
    const getdashboarddata = async () => {
        try {
            await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetDashboard`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('token')}`
                }
            }).then((res) => res.json()).then((response) => {
                if (response.status === 200) {
                    setdashboardData({
                        order: response.data.OrderCount,
                        revenue: response.data.Revenue,
                        user: response.data.UserCount,
                        abond: response.data.Abdoned,
                        warrantyRegistered: response.data.warrantyCount,
                        warrantyClaim: response.data.WarrantyClaimCount,
                        deliveredCount: response.data.deliveredCount,
                        cancelCount: response.data.cancelledCount,
                        deniedCount: response.data.deniedCount,
                        deniedRevenue: response.data.deniedRevenue,
                        deliveredRevenue: response.data.deliveredRevenue,
                        cancelledRevenue: response.data.cancelledRevenue
                    })

                } else {
                    if (response.message === "Access Denied") {

                        navigate('/')
                    }
                    toast.error(response.message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    setdashboardData(null)

                }
            })
        } catch (error) {
            console.error('API Error:', error);
        }

    }
    useEffect(() => {
        getdashboarddata()
    }, [])
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");



    const filterdashboard = async (date) => {
        setEndDate(date)
        if (startDate && date) {
            await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetDashboardbyDate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    "startdate": startDate,
                    "enddate": date
                })
            }).then((res) => res.json()).then((response) => {
                if (response.status === 200) {
                    setdashboardData({
                        order: response.data.OrderCount,
                        revenue: response.data.Revenue,
                        user: response.data.UserCount,
                        abond: response.data.Abdoned,
                        warrantyRegistered: response.data.warrantyCount,
                        warrantyClaim: response.data.WarrantyClaimCount,
                        deliveredCount: response.data.deliveredCount,
                        cancelCount: response.data.cancelledCount,
                        deniedCount: response.data.deniedCount,
                        deniedRevenue: response.data.deniedRevenue,
                        deliveredRevenue: response.data.deliveredRevenue,
                        cancelledRevenue: response.data.cancelledRevenue
                    })
                } else {

                    toast.error(response.message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    setdashboardData(null)

                }
            })
        } else {
            toast.error("Please Select Date", {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    return (
        <>
            <section className="dashbg-color">

                <div className="row">
                    <div className="col-lg-12">
                        <div className="dash-filters">
                            <form action="">
                                <input className="strt-date" type="date" placeholder="Start Date" value={startDate} onChange={(e) => {
                                    setStartDate(e.target.value);
                                    filterdashboard(endDate)
                                }} />
                            </form>

                            <form action="">
                                <input className="end-date" type="date" placeholder="End Date" value={endDate} onChange={(e) => {
                                    filterdashboard(e.target.value)
                                }} />
                            </form>
                        </div>
                    </div>
                </div>

                <div className="row  justify-content-center">
                    <div className="col-lg-10">
                        <div className="dash-cards">
                            <div className="row justify-content-center">
                                <div className="col-lg-5 user-card order-card">

                                    <p style={{ padding: "10px 0px", marginBottom: "0px" }}><b>Order</b></p>
                                    <div>
                                        <div className='d-flex justify-content-between'>
                                            <span className="text-primary" style={{
                                                color: "#19289F"
                                            }}>Total</span>
                                        <span className='text-primary fon-we'>{dashboardData?.order || 0}</span>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Delivered</span>
                                        <span className='text-success fon-we'>{dashboardData?.deliveredCount || 0}</span>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Cancelled</span>
                                        <span className='text-warning fon-we'>{dashboardData?.cancelCount || 0}</span>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Denied</span>
                                        <span className='text-danger fon-we'>{dashboardData?.deniedCount || 0}</span>
                                    </div>
                                </div>
                                <br />
                            </div>
                            <div className="col-lg-5 abond-card order-card">
                                <p style={{ padding: "10px 0px", marginBottom: "0px" }}><b>Revenue</b></p>
                                <div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Total</span>
                                        <span className='text-primary fon-we'>{dashboardData?.revenue?.toLocaleString() || 0}</span>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Delivered</span>
                                        <span className='text-success fon-we'>{dashboardData?.deliveredRevenue?.toLocaleString() || 0}</span>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Cancelled</span>
                                        <span className='text-warning fon-we'>{dashboardData?.cancelledRevenue?.toLocaleString() || 0}</span>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <span className="text-primary" style={{
                                            color: "#19289F"
                                        }}>Denied</span>
                                        <span className='text-danger fon-we'>{dashboardData?.deniedRevenue?.toLocaleString() || 0}</span>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-5 user-card order-card">
                                <div className="bg-circle"></div>
                                <div className="card-text">
                                    <h1>{dashboardData?.user || 0}</h1>
                                    <p>Total User</p>
                                </div>
                            </div>
                            <div className="col-lg-5 abond-card order-card">
                                <div className="bg-circle"></div>
                                <div className="card-text">
                                    <h1>{dashboardData?.abond || 0}</h1>
                                    <p>Abandoned Cart</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-5 order-card">
                                <div className="bg-circle"></div>
                                <div className="card-text">
                                    <h1>{dashboardData?.warrantyRegistered || 0}</h1>
                                    <p>Warranty Registered</p>
                                </div>
                            </div>
                            <div className="col-lg-5 revenue-card order-card">
                                <div className="bg-circle"></div>
                                <div className="card-text">
                                    <h1>{dashboardData?.warrantyClaim || 0} </h1>
                                    <p>Warranty Claim</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </section >
        </>
    );
}
export default Dashboard;
